import {
  GET_SHOP_STATISTICS,
  GET_SHOP_STATISTICS_SUCCESS,
} from "../../actions/statistics/types";

const initialState = {
  shopStatisticsLoading: false,
  shopStatisticsData: { values: [], labels: [] },
};

export const shops = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_SHOP_STATISTICS:
      return {
        ...state,
        shopStatisticsLoading: true,
      };
    case GET_SHOP_STATISTICS_SUCCESS:
      return {
        ...state,
        shopStatisticsLoading: false,
        shopStatisticsData: payload,
      };

    default: {
      return state;
    }
  }
};
